import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const SessionProvider = ({ children, session = {} }) => cloneElement(children, { session });

SessionProvider.propTypes = {
  children: PropTypes.node.isRequired,
  session: PropTypes.object,
};

const mapStateToProps = ({ session = {} }) => ({ session });

const ConnectedSessionProvider = connect(mapStateToProps)(SessionProvider);

export const withSession = Element => props => <ConnectedSessionProvider children={<Element {...props} />} />;

export default ConnectedSessionProvider;
